import { userConstants } from "../../constant";
const initialState = {
  cartItems: [],
};
export function cartItems(state = { initialState }, action) {
  switch (action.type) {
    case userConstants.GET_CART_ITEMS:
      return {
        cartItems: action.cartItems,
      };
    case userConstants.ADD_TO_CART:
      return {
        cartItems: action.cartItems,
      };
    case userConstants.REMOVE_FROM_CART:
      return {
        cartItem: action.payload,
      };
    default:
      return state;
  }
}
